// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la pestanya "Absències" de Gestió d'un Empleat.
   Totes les classes van prefixades amb "absencies-emp-" perquè no afectin
   cap altra pantalla: per revertir-ho n'hi ha prou en eliminar aquest
   fitxer i el seu import a AbsenciesEmpleat.js. La resta (formularis,
   botons) reutilitza les classes ja existents a dashboard.css.

   El bloc de filtres i el selector de vista reprodueixen el mateix patró
   visual de Treballs -> Tasques (treballs.css: .treballs-filtres i
   .treballs-vista-selector), sense dependre d'aquell fitxer, perquè els
   dos mòduls es puguin seguir revertint/modificant per separat. */

.absencies-emp-filtres {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  background: #f4f4f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.absencies-emp-filtres label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
}

.absencies-emp-filtres select {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 100px;
}

.absencies-emp-vista-selector {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.absencies-emp-vista-selector button {
  padding: 5px 14px;
  font-size: 13px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
  background: #f1f1f1;
  cursor: pointer;
  transition: background-color 0.2s;
}

.absencies-emp-vista-selector button:hover {
  background: #e0e0e0;
}

.absencies-emp-vista-selector button.active {
  background: #fff;
  border-bottom: 2px solid #fff;
  color: #0078d7;
}

.absencies-emp-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0 14px;
}

.absencies-emp-titol-mes {
  font-size: 18px;
  font-weight: 700;
  min-width: 160px;
  text-align: center;
}

/* --- Vista "Any complet": graella dels 12 mesos --- */
.absencies-emp-any-graella {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.absencies-emp-mes-bloc-petit {
  background-color: var(--dv2-surface, #ffffff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  padding: 10px;
  box-shadow: var(--dv2-shadow, none);
}

.absencies-emp-mes-titol {
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
}

/* --- Graella (comuna a vista Mes i vista Any) --- */
.absencies-emp-dies-setmana,
.absencies-emp-graella {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.absencies-emp-mes-bloc-petit .absencies-emp-dies-setmana,
.absencies-emp-mes-bloc-petit .absencies-emp-graella {
  gap: 2px;
}

.absencies-emp-dia-setmana {
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  color: var(--dv2-text-muted, #777);
}

.absencies-emp-dia {
  min-height: 64px;
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
  background-color: #fff;
}

.absencies-emp-dia:hover {
  background-color: #f0f4ff;
}

.absencies-emp-dia-buit {
  border: none;
  cursor: default;
  background: transparent;
}

.absencies-emp-dia-buit:hover {
  background: transparent;
}

.absencies-emp-dia-num {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.absencies-emp-dia-extrem {
  background-color: #cfe0ff;
  border-color: #6690e0;
}

.absencies-emp-dia-rang {
  background-color: #e6edff;
}

.absencies-emp-dia-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 3px;
}

.absencies-emp-chip {
  display: inline-block;
  font-size: 10px;
  line-height: 1.4;
  color: #fff;
  padding: 0 4px;
  border-radius: 3px;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.15s, transform 0.15s;
}

/* Pista visual de que el xip és clicable (per modificar/esborrar l'Absència),
   diferenciant-lo del clic sobre el fons del dia (que inicia una selecció
   nova). */
.absencies-emp-chip:hover {
  box-shadow: 0 0 0 2px #333 inset, 0 1px 3px rgba(0, 0, 0, 0.4);
  transform: scale(1.05);
}

.absencies-emp-chip-mes {
  font-size: 10px;
  color: #777;
}

/* --- Cel·la compacta (vista "Any complet"): mida reduïda, punts de color en
   comptes de xips de text, perquè hi càpiguen els 12 mesos alhora. --- */
.absencies-emp-dia-petit {
  min-height: 0;
  border: none;
  background: transparent;
  border-radius: 4px;
  padding: 4px 0;
  font-size: 12px;
  text-align: center;
}

.absencies-emp-dia-petit .absencies-emp-dia-num {
  font-size: 12px;
  font-weight: 700;
}

.absencies-emp-dia-petit.absencies-emp-dia-extrem {
  background-color: #0078d7;
  color: #fff;
}

.absencies-emp-dia-petit.absencies-emp-dia-rang {
  background-color: #d6ecff;
}

.absencies-emp-dia-punts {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 2px;
}

.absencies-emp-punt {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: transform 0.15s;
}

.absencies-emp-punt:hover {
  transform: scale(1.6);
}

.absencies-emp-ajuda {
  font-size: 12px;
  color: #666;
  font-style: italic;
  margin: 0 0 8px;
}

.absencies-emp-resum-seleccio {
  margin-top: 12px;
  font-size: 13px;
}

.absencies-emp-form {
  margin-top: 14px;
}

/* Formularis de Nova Absència / Modificar: mateixa tipografia i mateix
   estil de selects/inputs que .absencies-emp-filtres, per coherència
   visual dins la pestanya (en comptes de la mida per defecte de
   .Dashboard-form, que aquí no s'aplica perquè no hi ha cap contenidor
   amb classe "Dashboard-form"). */
.absencies-emp-form h4 {
  font-size: 14px;
  margin: 0 0 10px;
}

.absencies-emp-form label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 13px;
  font-weight: bold;
}

.absencies-emp-form select,
.absencies-emp-form input[type="time"],
.absencies-emp-form textarea {
  font-size: 13px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.absencies-emp-form textarea {
  width: 100%;
  max-width: 500px;
  height: 50px;
  resize: vertical;
}

.absencies-emp-form .checkbox-label {
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: bold;
}

.absencies-emp-avis-hores {
  font-size: 12px;
  font-style: italic;
  color: #888;
  align-self: center;
}

.absencies-emp-btn-petit {
  padding: 2px 8px;
  font-size: 12px;
}

.absencies-emp-btn-esborrar {
  background-color: #d9534f;
  color: #ffffff;
  border-color: #d9534f;
}

.absencies-emp-btn-esborrar:hover {
  background-color: #c9302c;
}

.absencies-emp-error {
  color: #d9534f;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/absenciesempleat.css"],"names":[],"mappings":"AAAA;;;;;;;;;kEASkE;;AAElE;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,qCAAqC;EACrC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;;EAEE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;;WAEW;AACX;EACE,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;kCAIkC;AAClC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* Estils específics de la pestanya \"Absències\" de Gestió d'un Empleat.\n   Totes les classes van prefixades amb \"absencies-emp-\" perquè no afectin\n   cap altra pantalla: per revertir-ho n'hi ha prou en eliminar aquest\n   fitxer i el seu import a AbsenciesEmpleat.js. La resta (formularis,\n   botons) reutilitza les classes ja existents a dashboard.css.\n\n   El bloc de filtres i el selector de vista reprodueixen el mateix patró\n   visual de Treballs -> Tasques (treballs.css: .treballs-filtres i\n   .treballs-vista-selector), sense dependre d'aquell fitxer, perquè els\n   dos mòduls es puguin seguir revertint/modificant per separat. */\n\n.absencies-emp-filtres {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 8px;\n  background: #f4f4f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.absencies-emp-filtres label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.absencies-emp-filtres select {\n  padding: 4px 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 100px;\n}\n\n.absencies-emp-vista-selector {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.absencies-emp-vista-selector button {\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: bold;\n  border: 1px solid #ccc;\n  border-radius: 4px 4px 0 0;\n  background: #f1f1f1;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.absencies-emp-vista-selector button:hover {\n  background: #e0e0e0;\n}\n\n.absencies-emp-vista-selector button.active {\n  background: #fff;\n  border-bottom: 2px solid #fff;\n  color: #0078d7;\n}\n\n.absencies-emp-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 6px 0 14px;\n}\n\n.absencies-emp-titol-mes {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 160px;\n  text-align: center;\n}\n\n/* --- Vista \"Any complet\": graella dels 12 mesos --- */\n.absencies-emp-any-graella {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.absencies-emp-mes-bloc-petit {\n  background-color: var(--dv2-surface, #ffffff);\n  border: 1px solid var(--dv2-border, #ddd);\n  border-radius: var(--dv2-radius, 8px);\n  padding: 10px;\n  box-shadow: var(--dv2-shadow, none);\n}\n\n.absencies-emp-mes-titol {\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 6px;\n  font-size: 13px;\n}\n\n/* --- Graella (comuna a vista Mes i vista Any) --- */\n.absencies-emp-dies-setmana,\n.absencies-emp-graella {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.absencies-emp-mes-bloc-petit .absencies-emp-dies-setmana,\n.absencies-emp-mes-bloc-petit .absencies-emp-graella {\n  gap: 2px;\n}\n\n.absencies-emp-dia-setmana {\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--dv2-text-muted, #777);\n}\n\n.absencies-emp-dia {\n  min-height: 64px;\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  padding: 4px;\n  cursor: pointer;\n  background-color: #fff;\n}\n\n.absencies-emp-dia:hover {\n  background-color: #f0f4ff;\n}\n\n.absencies-emp-dia-buit {\n  border: none;\n  cursor: default;\n  background: transparent;\n}\n\n.absencies-emp-dia-buit:hover {\n  background: transparent;\n}\n\n.absencies-emp-dia-num {\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n}\n\n.absencies-emp-dia-extrem {\n  background-color: #cfe0ff;\n  border-color: #6690e0;\n}\n\n.absencies-emp-dia-rang {\n  background-color: #e6edff;\n}\n\n.absencies-emp-dia-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-top: 3px;\n}\n\n.absencies-emp-chip {\n  display: inline-block;\n  font-size: 10px;\n  line-height: 1.4;\n  color: #fff;\n  padding: 0 4px;\n  border-radius: 3px;\n  cursor: pointer;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  transition: box-shadow 0.15s, transform 0.15s;\n}\n\n/* Pista visual de que el xip és clicable (per modificar/esborrar l'Absència),\n   diferenciant-lo del clic sobre el fons del dia (que inicia una selecció\n   nova). */\n.absencies-emp-chip:hover {\n  box-shadow: 0 0 0 2px #333 inset, 0 1px 3px rgba(0, 0, 0, 0.4);\n  transform: scale(1.05);\n}\n\n.absencies-emp-chip-mes {\n  font-size: 10px;\n  color: #777;\n}\n\n/* --- Cel·la compacta (vista \"Any complet\"): mida reduïda, punts de color en\n   comptes de xips de text, perquè hi càpiguen els 12 mesos alhora. --- */\n.absencies-emp-dia-petit {\n  min-height: 0;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  padding: 4px 0;\n  font-size: 12px;\n  text-align: center;\n}\n\n.absencies-emp-dia-petit .absencies-emp-dia-num {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.absencies-emp-dia-petit.absencies-emp-dia-extrem {\n  background-color: #0078d7;\n  color: #fff;\n}\n\n.absencies-emp-dia-petit.absencies-emp-dia-rang {\n  background-color: #d6ecff;\n}\n\n.absencies-emp-dia-punts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.absencies-emp-punt {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  transition: transform 0.15s;\n}\n\n.absencies-emp-punt:hover {\n  transform: scale(1.6);\n}\n\n.absencies-emp-ajuda {\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n  margin: 0 0 8px;\n}\n\n.absencies-emp-resum-seleccio {\n  margin-top: 12px;\n  font-size: 13px;\n}\n\n.absencies-emp-form {\n  margin-top: 14px;\n}\n\n/* Formularis de Nova Absència / Modificar: mateixa tipografia i mateix\n   estil de selects/inputs que .absencies-emp-filtres, per coherència\n   visual dins la pestanya (en comptes de la mida per defecte de\n   .Dashboard-form, que aquí no s'aplica perquè no hi ha cap contenidor\n   amb classe \"Dashboard-form\"). */\n.absencies-emp-form h4 {\n  font-size: 14px;\n  margin: 0 0 10px;\n}\n\n.absencies-emp-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.absencies-emp-form select,\n.absencies-emp-form input[type=\"time\"],\n.absencies-emp-form textarea {\n  font-size: 13px;\n  padding: 4px 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.absencies-emp-form textarea {\n  width: 100%;\n  max-width: 500px;\n  height: 50px;\n  resize: vertical;\n}\n\n.absencies-emp-form .checkbox-label {\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.absencies-emp-avis-hores {\n  font-size: 12px;\n  font-style: italic;\n  color: #888;\n  align-self: center;\n}\n\n.absencies-emp-btn-petit {\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.absencies-emp-btn-esborrar {\n  background-color: #d9534f;\n  color: #ffffff;\n  border-color: #d9534f;\n}\n\n.absencies-emp-btn-esborrar:hover {\n  background-color: #c9302c;\n}\n\n.absencies-emp-error {\n  color: #d9534f;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
